<div><app-ui-list [elements]="searchResult"></app-ui-list></div>
